import {Common, Requests} from 'etao-component-sp'
import {Base64} from 'js-base64'
import config from '@/config'
import {TENANT_KEY} from '@/components/login/secret'

let host = config.host.prod
if (process.env.NODE_ENV === 'development') {
    host = config.host.dev
}
let webSocketIp = config.webSocketIp
export {host, webSocketIp}

export const mesRequests = new Requests(host, {
    onRequest (config) {
        const common = new Common()

        // 安全请求header
        config.headers['Etao-Requested-With'] = 'EtaoHttpRequest'
        // headers判断是否需要
        const authorization = config.authorization === false
        if (!authorization) {
            config.headers['Authorization'] = `Basic ${Base64.encode(`etao:etao_secret`)}`
        }
        config.headers['Tenant-Id'] = localStorage.getItem(TENANT_KEY) || '000000'
        config.headers['lang'] = common.getData('lang') || 'zh_CN'
        let curOrg = common.getCurOrg()
        if (curOrg) {
            config.headers['Etao-CurOrgId'] = curOrg
        }
        // headers判断请求是否携带token
        const meta = (config.meta || {})
        const isToken = meta.isToken === false
        // headers传递token是否加密
        const cryptoToken = config.cryptoToken === true
        // 判断传递数据是否加密
        const cryptoData = config.cryptoData === true
        const token = common.getToken()
        if (token && !isToken) {
            config.headers['Etao-Auth'] = cryptoToken
                ? 'crypto ' + crypto.encryptAES(token, crypto.cryptoKey)
                : 'bearer ' + token
        }
        config.params = stripObjectItems(config.params || {})
        config.data = stripObjectItems(config.data || {})
        // 开启报文加密
        if (cryptoData) {
            if (config.params) {
                const data = crypto.encryptAES(JSON.stringify(config.params), crypto.aesKey)
                config.params = {data}
            }
            if (config.data) {
                config.text = true
                config.data = crypto.encryptAES(JSON.stringify(config.data), crypto.aesKey)
            }
        }

        return config
    }
})

/**
 * 去除对象值前后空格，数组内前后空格
 * @param data
 */
function stripObjectItems (data) {
    if (typeof data === 'string') {
        return data.trim()
    }
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            if (typeof data[key] === 'string') {
                data[key] = data[key].trim()
            } else if (Array.isArray(data[key])) {
                data[key].forEach((index, item) => {
                    if (typeof item === 'string') {
                        data[key][index] = item.trim()
                    } else if (typeof item === 'object') {
                        stripObjectItems(item)
                    }
                })
            } else if (typeof data[key] === 'object') {
                stripObjectItems(data[key])
            }
        }
    }
    return data
}



// WEBPACK FOOTER //
// ./src/api/index.js